import React, { useState, useEffect } from 'react';
import { Empty } from 'antd';
import { useTranslation } from 'react-i18next';

import { Container, Header, Actions, TableColumn } from './styles';

export function Table({
  children = null,
  actionSize = '200px',
  pagination = false,
  pageSize = 10,
  empty = true,
  ...props
}) {
  const { t } = useTranslation();

  const [windowWidth, setWindowWidth] = useState(null);

  const noData = <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('screens:noData')} />;

  const sizeOfThings = () => {
    let windowWidth = window.innerWidth;
    setWindowWidth(windowWidth);
  };

  window.addEventListener('resize', function () {
    sizeOfThings();
  });

  useEffect(() => {
    sizeOfThings();
  });

  return windowWidth < 500 ? (
    <Container actionSize={actionSize} {...props} pagination={pagination} locale={{ emptyText: noData }}>
      {children}
    </Container>
  ) : (
    <Container
      actionSize={actionSize}
      {...props}
      pagination={
        pagination && {
          pageSize: pageSize,
          showTotal: (total, range) =>
            `${t('screens:pagination.showing')} ${range[0]} ${t('screens:pagination.to')} ${range[1]} ${t(
              'screens:pagination.of'
            )} ${total} ${t('screens:pagination.records')}`,
        }
      }
      locale={{ emptyText: empty ? noData : '' }}
    >
      {children}
    </Container>
  );
}

export function TableHeader({ children = null }) {
  return <Header className="table-header">{children}</Header>;
}

export function TableActions({ children = null, align, justify, isMobile }) {
  return (
    <Actions className="table-header" align={align} justify={justify} isMobile={isMobile}>
      {children}
    </Actions>
  );
}

export function Column({ children = null, ...props }) {
  return <TableColumn {...props}>{children}</TableColumn>;
}
